exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhtml {\n    width: 100%;\n    height: 100%;\n}\n\nbody {\n    width: 100%;\n    height: 100%;\n    /*background-color: #f5f5f5;*/\n    background-color: #fff;\n    -webkit-text-size-adjust: 100% !important;\n    /*font-family: priceFont;*/\n    font-family: sans-serif;\n}\npre {\n    font-family: sans-serif;\n}\n\n#approot {\n    width: 100%;\n    height: 100%;\n    /*background: #f4f5f8;*/\n    background: #fff;\n}\n\n/*@font-face {*/\n    /*font-family: priceFont;*/\n    /*src: url('./pingfang_en.woff') format(\"woff\");*/\n/*}*/\n\n.weui-picker {\n    font-size: 16px;\n    touch-action: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/common.css
// module id = 526
// module chunks = 0 1 161